import { Injectable } from '@angular/core';
import { Building, SessionService } from '@edl-development/edl-common';
import { firstValueFrom, forkJoin } from 'rxjs';
import { BuildingService } from '../building.service';
import { PaetepPortalService } from '../paetep-portal.service';
import { PermissionsService } from '../permissions/permissions.service';
import { LocalStorageKeys } from 'src/app/model/enum/local-storage-keys.enum';
import * as _ from 'lodash';

@Injectable({
    providedIn: 'root'
})
export class SessionHelpersService {

    constructor(
        private sessionService: SessionService,
        private buildingService: BuildingService,
        private paetepPortalService: PaetepPortalService,
        private permissionsService: PermissionsService
    ) { }

    getDefaultSchoolYear(): string {
        const sYs: any = this.sessionService.GetSessionValue('school_years');
        const dsY: any = this.sessionService.GetSessionValue('user_default_schoolYear');
    
        return dsY != undefined ? dsY : sYs[0];
    }

    getDefaultBuildingID(buildings: Building[] = []): number | undefined {
        const defaultBuildingId = this.sessionService.GetSessionValue('user-default-building') as number;

        return buildings.find(b => b.buildingID == defaultBuildingId)?.buildingID ?? buildings[0].buildingID;
    }

    loadSessionData = () => {
        return firstValueFrom(
            forkJoin({
                buildings: this.buildingService.getPortalBuildings(),
                portalModuleSettings: this.paetepPortalService.getPortalModuleSettings(),
                permissions: this.permissionsService.getMyPermissions(),
                rolesICanManage: this.permissionsService.getRolesICanManage(),
                rolesICanManagePerBuilding: this.permissionsService.getRolesICanManagePerBuilding()
            })
        ).then(({ buildings, portalModuleSettings, permissions, rolesICanManage, rolesICanManagePerBuilding }) => {
            let sortedBuildings = _.sortBy(buildings, 'name');
            const permissionsMap = this.generatePermissionsMap(permissions);
            this.sessionService.SetSessionValue('edl_portal_buildings', sortedBuildings);
            this.sessionService.SetSessionValue('edl_portal_module_settings', portalModuleSettings );
            this.sessionService.SetSessionValue(LocalStorageKeys.PERMISSIONS, permissionsMap);
            this.sessionService.SetSessionValue(LocalStorageKeys.ROLES_I_CAN_MANAGE, rolesICanManage);
            this.sessionService.SetSessionValue(LocalStorageKeys.ROLES_I_CAN_MANAGE_PER_BUILDING, rolesICanManagePerBuilding);
        });
    }

    private generatePermissionsMap(permissions?: string[] | null) {
        return permissions?.reduce((currentMap: {[key: string]: boolean}, permission: string) => (currentMap[permission] = true, currentMap), {}) ?? {}
    }
}
